import React from "react";
import dayjs from "dayjs";
import BoardCard from "components/dashboard/BoardCard";
import { DATE_FORMAT } from "config/constant";
import { DashboardTable } from "../DashboardTable";
import useLatestArchivesQuery from "features/document/hooks/queries/useLatestArchivesQuery";
import { ROUTER_PATH } from "config/path";
import styled, { css } from "styled-components";
import openPdfPreview from "utils/openPdfPreview";

const ArchivesCard = () => {
  const { data: latestArchivesResponse } = useLatestArchivesQuery();
  const { contents, totalElements } = latestArchivesResponse || {};

  return (
    <BoardCard title="Archives" to={ROUTER_PATH.document.archive.dashboard}>
      <TableStyle>
        <DashboardTable.Thead>
          <DashboardTable.Tr>
            <DashboardTable.Th>No.</DashboardTable.Th>
            <DashboardTable.Th>문서구분</DashboardTable.Th>
            <DashboardTable.Th>파일명</DashboardTable.Th>
            <DashboardTable.Th>등록일</DashboardTable.Th>
          </DashboardTable.Tr>
        </DashboardTable.Thead>
        <DashboardTable.Tbody>
          {contents?.map((item, index) => {
            const articleIndex = totalElements ? totalElements - index : 5;

            return (
              <ClickableRowStyle
                key={item.uuid}
                onClick={() => {
                  void openPdfPreview(item.documentFileUrl, item.title);
                }}
              >
                <DashboardTable.Td>
                  {String(articleIndex).padStart(5, "0")}
                </DashboardTable.Td>
                <DashboardTable.Td>
                  {item.documentClassDto.name}
                </DashboardTable.Td>
                <DashboardTable.Td>{item.title}</DashboardTable.Td>
                <DashboardTable.Td>
                  {dayjs(item.createdAt).format(DATE_FORMAT)}
                </DashboardTable.Td>
              </ClickableRowStyle>
            );
          })}
        </DashboardTable.Tbody>
      </TableStyle>
    </BoardCard>
  );
};

export default ArchivesCard;

/* 스타일 */
const TableStyle = styled(DashboardTable.Table)`
  th {
    &:nth-child(1) {
      width: 6.4rem;
    }
    &:nth-child(2) {
      width: 5.4rem;
    }
    &:nth-child(4) {
      width: 12.4rem;
    }

    ${({ theme }) => css`
      ${theme.media.small} {
        &:nth-child(2) {
          width: 7rem;
        }
        &:nth-child(4) {
          width: 8rem;
        }
      }
    `}
  }

  td {
    &:nth-child(1) {
      color: ${({ theme }) => theme.color.text.tertiery};
    }
    &:nth-child(2) {
      color: ${({ theme }) => theme.color.text.secondary};
    }
    &:nth-child(3) {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding-right: 0;
    }
    &:nth-child(4) {
      color: ${({ theme }) => theme.color.text.secondary};
      text-align: right;
    }

    ${({ theme }) => css`
      ${theme.media.notSmall} {
        &:nth-child(1) {
          padding-left: 0;
          padding-right: 0;
        }
        &:nth-child(2) {
          padding-left: 0;
          padding-right: 0;
        }
        &:nth-child(3) {
          padding-right: 0;
        }
      }
    `}
  }
`;

const ClickableRowStyle = styled(DashboardTable.Tr)`
  cursor: pointer;
`;
